import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


const PopularLearn = ({ courseOutline }) => {
    const { sublist1, sublist2, sublist3, sublist4 } = courseOutline;
    return (
        <div>
            <ul className='outline'>
                <li className='outline-list'>{sublist1}</li>
                <li className='outline-list'>{sublist2}</li>
                <li className='outline-list'>{sublist3}</li>
                <li className='outline-list'>{sublist4}</li>
            </ul>
        </div>
    );
};

export default PopularLearn;